export const GET_CHANNELS_SUCCEEDED = 'Messages/GET_CHANNELS_SUCCEEDED';
export const GET_CHANNELS_ERROR = 'Messages/GET_CHANNELS_ERROR';

export const READ_STATUS_UPDATED = 'Messages/READ_STATUS_UPDATED';
export const MESSAGE_ADDED = 'Messages/MESSAGE_ADDED';
export const CHANNEL_ADDED = 'Messages/CHANNEL_ADDED';
export const CHANNEL_REMOVED = 'Messages/CHANNEL_REMOVED';

export const GET_CHAT_PRESETS_SUCCEEDED = 'Messages/GET_CHAT_PRESETS_SUCCEEDED';
export const GET_CHAT_PRESETS_ERROR = 'Messages/GET_CHAT_PRESETS_ERROR';

export const CHECK_KICKSTART_SUCCEEDED = 'Messages/CHECK_KICKSTART_SUCCEEDED';
export const CHECK_KICKSTART_ERROR = 'Messages/CHECK_KICKSTART_ERROR';

export const GET_MESSAGES_FIRST_PAGE_SUCCEEDED =
  'Messages/GET_MESSAGES_FIRST_PAGE_SUCCEEDED';
export const GET_MESSAGES_FIRST_PAGE_ERROR =
  'Messages/GET_MESSAGES_FIRST_PAGE_ERROR';

export const GET_MESSAGES_PREV_PAGE_SUCCEEDED =
  'Messages/GET_MESSAGES_PREV_PAGE_SUCCEEDED';
export const GET_MESSAGES_PREV_PAGE_ERROR =
  'Messages/GET_MESSAGES_PREV_PAGE_ERROR';

export const CLEAR_ACTIVE_CHANNEL_STATE = 'Messages/CLEAR_ACTIVE_CHANNEL_STATE';

export const START_LOADING_MESSAGES = 'Messages/START_LOADING_MESSAGES';
